'use client'
import { signerToEcdsaValidator } from '@zerodev/ecdsa-validator';
import { toMultiChainECDSAValidator } from '@zerodev/multi-chain-ecdsa-validator';

const getEcdsaValidator = (ecdsaProviderType) => {
    if (ecdsaProviderType === 'zerodev_signer_to_ecdsa') {
        return signerToEcdsaValidator;
    }
    else if (ecdsaProviderType === 'zerodev_multi_chain') {
        return toMultiChainECDSAValidator;
    }
    else {
        return signerToEcdsaValidator;
    }
};

export { getEcdsaValidator };
